import { TableName } from "../../../tables"
import { O } from "../state/types"
import { ButtonKind } from "./button/types"

export enum FieldType {
    TEXT = 'text',
    LONG_TEXT = 'long-text',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    PRICE = 'price',
    PERCENTAGE = 'percentage',
    SELECT = 'select',
    DATE = 'date',
    IMAGE = 'image',
    FILE = 'file',
    TABLE = 'table'
}

export enum FormatType {
    DNI,
    CUIT_CUIL,
    PHONE,
    PLATE
}

export type TextOrNumber = string | number
export type FieldValue = TextOrNumber | boolean | Date | File

export type FormFieldProps<T> = {
    key?: string
    name: string
    type: FieldType
    table?: TableName
    label?: string
    labelSpace?: number,
    value?: T
    defaultValue?: T
    hint?: string
    options?: Option[]
    placeholder?: string
    min?: number | Date
    max?: number | Date
    integer?: boolean
    round?: boolean
    icon?: string
    optional?: boolean
    disabled?: boolean
    narrow?: boolean
    focus?: boolean
    loading?: boolean
    className?: string
    render?: () => JSX.Element
    renderInputLabel?: (optionValue: string) => string
    renderOption?: (option: Option, onClick?: (e: React.MouseEvent<HTMLElement>) => void) => Promise<JSX.Element>
    onChange?: (value?: T) => void
    onCreateNew?: () => void
    validate?: (data: Data) => string | null
}

export type FormField = FormFieldProps<FieldValue>

export type EditableFormField = FormField & {
    onSave?: (value?: FieldValue) => void
}

export type FilterField = FormField & {
    space?: number
    required?: boolean
    onChange: (value?: FieldValue) => void
}

export type FilterField2 = FormField & {
    space?: number
    onChange?: (value?: FieldValue) => void
}

export type FiltersOptions = {
    filtersKey: string
    search?: {
        placeholder?: string
    }
    filterFields?: FilterField2[]
    // Valores iniciales de filtros que el usuario no tiene guardados. Al buscar por texto se ignoran si el usuario no los tocó.
    defaultFiltersData?: Data
    filtersTextAffix?: string
    firstRowLength?: number
}

export type Data = {
    [key: string]: O<FieldValue>
}

export type Column = {
    name: string,
    type: FieldType
    table?: TableName
    label: string,
    loading?: boolean
    render?: (value?: FieldValue) => string | JSX.Element
    renderLabel?: () => JSX.Element
    sortable?: boolean
    sortKey?: string
    sortValue?: (value?: FieldValue) => string | number
}

export type Option = {
    value: string
    label: string
}

export type DetailFieldProps = {
    name: string,
    type: FieldType
    table?: TableName
    label?: string,
    labelSpace?: number,
    loading?: boolean,
    render?: (value?: FieldValue) => JSX.Element,
}

export type Tab = {
    id: string
    title: string
    content: JSX.Element
}

export type Action = {
    label?: string
    kind?: ButtonKind
    icon?: string
    tooltip?: string
    tooltipLines?: string[]
    disabled?: boolean
    small?: boolean
    href?: string
    onClick?: (value?: string) => void
}

export type Crumb = {
    label: string
    path?: string
    onClick?: () => void
}

export type CustomOnClickEvent = {
    stopPropagation?: () => void
    target?: {
        id?: string
        value?: string
        parentElement?: {
            click: (e: CustomOnClickEvent) => void
        }
    }
}

export type CustomOnDivClickEvent = React.MouseEvent<HTMLElement> & {
    target?: {
        id?: string
        value?: string
    }
}
